import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "video-section" }
const _hoisted_2 = { class: "index-sections" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, [
    /*#__PURE__*/_createTextVNode("Articles "),
    /*#__PURE__*/_createElementVNode("span", { class: "gradient-text" }, " list")
  ])
], -1)
const _hoisted_4 = { class: "articles-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArticleComponent = _resolveComponent("ArticleComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articleData, (article) => {
          return (_openBlock(), _createBlock(_component_ArticleComponent, {
            key: article.title,
            title: article.title,
            img: article.img,
            articleurl: article.url,
            subTitle: article.subTitle
          }, null, 8, ["title", "img", "articleurl", "subTitle"]))
        }), 128))
      ])
    ])
  ]))
}